module.exports = __webpack_public_path__ + "static/media/Dark_horizontal.8a85b7b4.svg";